import { ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA, BUSCAR_FECHAMENTO_DIA } from '../../actions/types'

const initialState = undefined
const itemInicial = { totais: {} }

export default function reducerFechamentoCaixaDia (state = itemInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_FECHAMENTO_DIA: {
      return action.payload.data;
    }

    case ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA: {
      const { fechamento } = action.payload;
      const detalhamento = action.payload.response ? action.payload.response.data : null;
      const nova = Object.assign({}, fechamento, { exibirConteudo: !fechamento.exibirConteudo });
      if (detalhamento) {
        nova.detalhamento = detalhamento;
      }


      return nova;
    }

    default: {
      return state
    }
  }
}
